<template>
  <div class="download-page">
    <div class="contain">
      <div class="logo">
        <img :src="require('@/assets/img/download/download_1.png')" alt="雲林幣" />
      </div>

      <div class="qrcode">
        <!-- iOS -->
        <div class="qr_box qr_left">
          <div class="qr_img">
            <img
              :src="require('@/assets/img/download/download_2.png')"
              alt="iOS 下載 QR Code"
            />
          </div>
          <div class="qr_btn">
            <a :href="iosUrl" target="_blank" rel="noopener">
              <img
                :src="require('@/assets/img/download/download_3.png')"
                alt="App Store 下載"
              />
            </a>
          </div>
          <br />
          ↑ 點擊即可下載
        </div>

        <!-- Android -->
        <div class="qr_box qr_right">
          <div class="qr_img">
            <img
              :src="require('@/assets/img/download/and.png')"
              alt="Android 下載 QR Code"
            />
          </div>
          <div class="qr_btn">
            <a :href="androidUrl" target="_blank" rel="noopener">
              <img
                :src="require('@/assets/img/download/download_4.png')"
                alt="Google Play 下載"
              />
            </a>
          </div>
          <br />
          ↑ 點擊即可下載
        </div>
      </div>

      <div class="bottom">
        <img
          :src="require('@/assets/img/download/download_5.png')"
          alt="雲林Nubi扭一下"
        />
        <div class="words">
          雲林縣數位縣民平台
          <div class="fb">
            <a :href="facebookUrl" target="_blank" rel="noopener">
              <img
                :src="require('@/assets/img/download/download_6.png')"
                alt="Facebook"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Download',
  data() {
    return {
      iosUrl:
        'https://apps.apple.com/tw/app/%E9%9B%B2%E6%9E%97nubi%E6%89%AD%E4%B8%80%E4%B8%8B/id1546439181',
      androidUrl:
        'https://play.google.com/store/apps/details?id=com.yulingov.yulincoin',
      facebookUrl:
        'https://www.facebook.com/%E9%9B%B2%E6%9E%97Nubi%E6%89%AD%E4%B8%80%E4%B8%8B-121953866377791/',
    };
  },
};
</script>

<style scoped lang="scss">
.download-page {
  width: 100%;
  min-height: 100vh;
  margin: 0;
  font-family: arial, 'Microsoft JhengHei', '微軟正黑體', sans-serif;
  background: linear-gradient(1deg, rgb(249, 190, 0), rgb(248, 232, 66));
  overflow-x: hidden;
}

.contain {
  width: 100%;
  margin: auto;
}

.contain div img {
  width: 100%;
}

.logo {
  position: relative;
  width: 306px;
  margin: 60px auto;
}

.qrcode {
  position: relative;
  width: 100%;
  margin: auto;
  text-align: center;
}

.qr_box {
  display: inline-block;
  margin-bottom: 60px;
}

.qr_img {
  margin-bottom: 20px;
}

.qr_left {
  margin-right: 40px;
}

.bottom {
  position: relative;
  width: 226px;
  margin: auto auto 30px;
}

.bottom .words {
  text-align: center;
  font-size: 20px;
  margin-top: 40px;
  max-width: none;
}

.bottom .words .fb {
  width: 49px;
  vertical-align: middle;
  margin: 20px auto;
}

@media screen and (max-width: 468px) {
  .contain div {
    max-width: 90%;
  }

  .contain .qrcode div {
    max-width: 100%;
  }

  .qr_left {
    margin-right: 0;
  }
}
</style>
